
document.addEventListener('DOMContentLoaded', function () {
    var cc = initCookieConsent();
    var defaultTexts = {
        de: {
            consent_modal: {
                title: 'Unsere Cookies',
                description: 'Wir verwenden auf unserer Website Cookies um dir das bestmögliche Online-Erlebnis zu bieten. Die Cookies sind notwendig, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Teilweise werden auch Cookies von ausgewählten Partnern verwendet. Wir nehmen Datenschutz ernst und respektieren deine Privatsphäre.',
                policy_text: 'Bitte lies unsere {privacyPolicy} um weitere Details zu erfahren.',
                primary_btn: 'Alle akzeptieren',
                secondary_btn: 'Cookie Einstellungen',
            },
            settings_modal: {
                title: 'Unsere Cookies',
                save_settings_btn: 'Einstellungen speichern',
                accept_all_btn: 'Alle akzeptieren',
                reject_all_btn: 'Alle ablehnen',
                close_btn_label: 'Schliessen',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Expiration'},
                ],
            },
            settings: {
                privacy_link_text: 'Datenschutzerklärung',
                essentials: {
                    title: 'Essenziell',
                    description: 'Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.'
                },
                about_cookies: {
                    title: 'Über Cookies',
                    description: 'Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten. Laut Gesetz können wir Cookies auf deinem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir deine Erlaubnis. Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien platziert, die auf unseren Seiten erscheinen. Du kannst deine Einwilligung jederzeit von der Cookie-Erklärung auf unserer Website ändern oder widerrufen.'
                },
                category: {
                    analytics: {
                        title: 'Statistik & Marketing',
                        description: 'Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.',
                    },
                    functional: {
                        title: 'Funktional',
                        description: 'Funktionale-Cookies ermöglichen einer Webseite sich an Informationen zu erinnern, die die Art beeinflussen, wie sich eine Webseite verhält oder aussieht.',
                    },
                },
            },
        },
        en: {
            consent_modal: {
                title: 'We use cookies!',
                description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
                policy_text: 'Please read our {privacyPolicy} for more details.',
                primary_btn: 'Accept all',
                secondary_btn: 'Settings',
            },
            settings_modal: {
                title: 'Cookie preferences',
                save_settings_btn: 'Save settings',
                accept_all_btn: 'Accept all',
                reject_all_btn: 'Reject all',
                close_btn_label: 'Close',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Expiration'},
                ],
            },
            settings: {
                privacy_link_text: 'Privacy policy',
                essentials: {
                    title: 'Essential',
                    description: 'Essential cookies enable basic functions and are necessary for the proper functioning of the website.'
                },
                about_cookies: {
                    title: 'About cookies',
                    description: 'Cookies are small text files used by websites to make the user experience more efficient. By law, we can store cookies on your device if they are strictly necessary for the operation of this site. For all other cookie types we need your permission. This site uses different types of cookies. Some cookies are placed by third parties that appear on our pages. You can change or withdraw your consent at any time from the cookie statement on our website.',
                },
                category: {
                    analytics: {
                        title: 'Statistiques et marketing',
                        description: 'Les cookies statistiques aident les propriétaires de sites web à comprendre comment les visiteurs interagissent avec les sites web en collectant et en rapportant des informations de manière anonyme.',
                    },
                    functional: {
                        title: 'Fonctionnel',
                        description: 'Les cookies fonctionnels permettent à un site web de mémoriser des informations qui influencent son comportement ou son apparence.',
                    },
                },
            },
        },
        fr: {
            consent_modal: {
                title: 'Notre Cookies',
                description: 'FR Wir verwenden auf unserer Website Cookies um dir das bestmögliche Online-Erlebnis zu bieten. Die Cookies sind notwendig, um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Teilweise werden auch Cookies von ausgewählten Partnern verwendet. Wir nehmen Datenschutz ernst und respektieren deine Privatsphäre.',
                policy_text: 'FR Bitte lies unsere {privacyPolicy} um weitere Details zu erfahren.',
                primary_btn: 'Accepter tous',
                secondary_btn: 'Paramètres des cookies',
            },
            settings_modal: {
                title: 'Notre Cookies',
                save_settings_btn: 'enregistrer les paramètres',
                accept_all_btn: 'Accepter tous',
                reject_all_btn: 'Reguser tous',
                close_btn_label: 'Fermer',
                cookie_table_headers: {
                    col1: 'Nom',
                    col2: 'Domain',
                    col3: 'Expiration',
                },
            },
            settings: {
                privacy_link_text: 'politique de confidentialit\xE9',
                essentials: {
                    title: 'Essenziell',
                    description: 'Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.'
                },
                about_cookies: {
                    title: 'Über Cookies',
                    description: 'Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten. Laut Gesetz können wir Cookies auf deinem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir deine Erlaubnis. Diese Seite verwendet unterschiedliche Cookie-Typen. Einige Cookies werden von Drittparteien platziert, die auf unseren Seiten erscheinen. Du kannst deine Einwilligung jederzeit von der Cookie-Erklärung auf unserer Website ändern oder widerrufen.'
                },
                category: {
                    analytics: {
                        title: 'Statistiques et marketing',
                        description: 'Les cookies statistiques aident les propriétaires de sites web à comprendre comment les visiteurs interagissent avec les sites web en collectant et en rapportant des informations de manière anonyme.',
                    },
                    functional: {
                        title: 'Fonctionnel',
                        description: 'Les cookies fonctionnels permettent à un site web de mémoriser des informations qui influencent son comportement ou son apparence.',
                    },
                },
            },
        },
    };

    var currentLocale = document.getElementsByTagName("html")[0].getAttribute("lang");
    var privacyPolicyUrl = `/${currentLocale}/datenschutz`;
    var mustConsent = currentLocale !== "ch";
    if (!defaultTexts[currentLocale]) {
        defaultTexts[currentLocale] = defaultTexts.de;
    }

    function translateKey(key, defaultText) {
        return defaultText;
        // var text = translate.t(key);
        // if (text === key) {
        //     return defaultText;
        // }
        // return text;
    }

    var modalBlocks = [];
    var purposes = [];
    var privacyLink = `<a href="${privacyPolicyUrl}">${translateKey("cookiemessage_consent_policy_name", defaultTexts[currentLocale].settings.privacy_link_text)}</a>`;

    var consentMessage = translateKey("cookiemessage_consent_message", defaultTexts[currentLocale].consent_modal.description);
    consentMessage = consentMessage.replaceAll('{privacyPolicy}', privacyLink);

    var privacyMessage = '<br/>' + translateKey("cookiemessage_consent_policy_message", defaultTexts[currentLocale].consent_modal.policy_text);
    privacyMessage = privacyMessage.replaceAll('{privacyPolicy}', privacyLink);

    modalBlocks.push({
        description: consentMessage + privacyMessage,
    });
    modalBlocks.push({
        title: translateKey('cookiemessage_settings_essentials_title', defaultTexts[currentLocale].settings.essentials.title),
        description: translateKey('cookiemessage_settings_essentials_description', defaultTexts[currentLocale].settings.essentials.description),
        toggle: {
            value: 'necessary',
            enabled: true,
            readonly: true,
        },
    });
    let categories = {};
    document.querySelectorAll('[data-cookiecategory]').forEach((element) => {
        //do not add same app twice
        var category = element.getAttribute('data-cookiecategory');
        if (categories.hasOwnProperty(category)) {
            var name = element.getAttribute('data-title');
            if (!categories[category].list.some((element) => element === name)) {
                categories[category].list.push(name);
            }
            return;
        }

        var c = {
            title: translateKey(`cookiemessage_settings_cookie_${category}_title`, defaultTexts[currentLocale].settings.category[category]?.title ?? element.getAttribute('data-category-name') ?? element.getAttribute('data-title')),
            description: translateKey(`cookiemessage_settings_cookie_${category}_description`, defaultTexts[currentLocale].settings.category[category]?.description ?? element.getAttribute('data-category-description') ?? ""),
            list: [element.getAttribute('data-title')],
            toggle: {
                value: category,
                enabled: !mustConsent,
                readonly: false,
            },
        };
        purposes.push(element.getAttribute('data-cookiecategory'));
        categories[category] = c;
    });
    for (const [key, category] of Object.entries(categories)) {
        category.description = category.description + '<ul style="padding-left:2rem;margin-top:2rem;"><li>' + category.list.join('</li><li>') + '</li></ul>';
        modalBlocks.push(category);
    }
    modalBlocks.push({
        title: translateKey("cookiemessage_settings_about_cookies_title", defaultTexts[currentLocale].settings.about_cookies.title),
        description: translateKey("cookiemessage_settings_about_cookies_description", defaultTexts[currentLocale].settings.about_cookies.description),
    });

    var config = {
        current_lang: currentLocale,
        autoclear_cookies: true,
        page_scripts: true,
        force_consent: mustConsent,
        autorun: false,
        mode: mustConsent ? 'opt-in' : 'opt-out',
        cookie_domain: location.hostname,

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        // auto_language: null                     // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        revision: 0,                            // default: 0
        onFirstAction: function (user_preferences, cookie) {
            // callback triggered only once
        },
        onAccept: function (cookie) {
            document.dispatchEvent(new CustomEvent('cookiebundle-on-accept-or-change', {detail: cookie}));
        },
        onChange: function (cookie, changed_preferences) {
            document.dispatchEvent(new CustomEvent('cookiebundle-on-accept-or-change', {detail: cookie}));
        },
        languages: {}
    };

    config.languages[currentLocale] = {
        consent_modal: {
            title: translateKey('cookiemessage_consent_title', defaultTexts[currentLocale].consent_modal.title),
            description: translateKey('cookiemessage_notice_message', consentMessage).replaceAll('{purposes}', purposes.join(", ")) + privacyMessage,
            primary_btn: {
                text: translateKey('cookiemessage_consent_accept_all_btn', defaultTexts[currentLocale].consent_modal.primary_btn),
                role: 'accept_all',
            },
            secondary_btn: {
                text: translateKey('cookiemessage_consent_secondary_btn', defaultTexts[currentLocale].consent_modal.secondary_btn),
                role: 'settings',
            },
        },
        settings_modal: {
            title: translateKey('cookiemessage_settings_title', defaultTexts[currentLocale].settings_modal.title),
            save_settings_btn: translateKey('cookiemessage_settings_save_settings_btn', defaultTexts[currentLocale].settings_modal.save_settings_btn),
            accept_all_btn: translateKey('cookiemessage_settings_accept_all_btn', defaultTexts[currentLocale].settings_modal.accept_all_btn),
            reject_all_btn: translateKey('cookiemessage_settings_reject_all_btn', defaultTexts[currentLocale].settings_modal.reject_all_btn),
            close_btn_label: translateKey('cookiemessage_settings_close_btn_label', defaultTexts[currentLocale].settings_modal.close_btn_label),
            cookie_table_headers: [
                {col1: translateKey('cookiemessage_settings_modal_table_col1', defaultTexts[currentLocale].settings_modal.cookie_table_headers.col1)},
                {col2: translateKey('cookiemessage_settings_modal_table_col1', defaultTexts[currentLocale].settings_modal.cookie_table_headers.col2)},
                {col3: translateKey('cookiemessage_settings_modal_table_col1', defaultTexts[currentLocale].settings_modal.cookie_table_headers.col3)},
            ],
            blocks: modalBlocks,
        }
    };

    cc.run(config);
    cc.show();

    function showCookieWindow() {
        cc.showSettings(0);
    }
    window.showCookieWindow = showCookieWindow;
});